import FileSaver from 'file-saver';
import { userService } from '@saucelabs/sl-util-axios';

import { generateReportName } from './../activity/utils';

export const getGroup = (id) => (
  userService.get(`/v1/groups/${id}/`)
);

export const updateGroup = (id, data) => (
  userService.patch(`/v1/groups/${id}/`, data)
);

export const getGroupUserList = (id, params) => (
  userService.get(`/v1/groups/${id}/members`, { params })
);

export const setGroupConcurrency = (id, data) => (
  userService.patch(`/v1/groups/${id}/set-batch-concurrency/`, data)
);

export const removeTeamFromGroup = (teamId, groupId) => (
  userService.delete(`/v1/groups/${groupId}/teams/${teamId}`)
);

export const getGroupTeamsUsageCSV = ({ id, name }) => (
  userService.get(`/v1/groups/${id}/teams-activity/`, {
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  }).then(({ data }) => {
    FileSaver.saveAs(data, generateReportName({
      rootSection: name,
      reportType: 'all',
    }));
  })
);
